exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.forum-photo[data-v-243460e8] {\n    width: 100%;\n    height: auto;\n}\n.forum-photo-add[data-v-243460e8] {\n    border: 2px dashed #dddddd;\n}\n.forum-photo-add[data-v-243460e8]:hover {\n    border: 2px dashed #666666;\n    transition: all .5s ease 0.1s\n}\n.overlay[data-v-243460e8] {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n", ""]);

// exports
